import checkPermission from './utils/checkPermission';

// props
// permissions
// userPermissions
const Permission = (props) => {
  const { permissions, grantPermissions } = props;

  const hasPermission = checkPermission(permissions, grantPermissions);

  return props.children({ hasPermission, permissions, grantPermissions });
};

export default Permission;



// WEBPACK FOOTER //
// ./src/components/permission/permission.js